<template>
  <modal @close="clearField" width="375px" height="auto" minHeight="auto">
    <div class="popup-sendPhone p-10 pb-11" slot="body">
      <send_request :form_type="1" :user_info="user_info" :close="close" @close="clearField"/>
    </div>
  </modal>
</template>


<script>
import modal from "../../athoms/Modal.vue";
import send_request from "../forms/Send_request.vue"
import { setTimeout } from 'timers';
export default {
  components: { modal, send_request },
  data() {
    return {
      close: false
    }
  },
  props: {
    user_info: Object,
  },
  methods: {
    // ф-ия очистки
    clearField() {
      this.$emit("close");
      this.close = true;
      setTimeout(() => {
        this.close = false;
      }, 3000);
    },
  }
};
</script>
